const document =
{
    button : 'Imprimer l\'observation',
    title  : 'Actions'
};

export default document ;